import {
  Avatar, Box, Fade
} from "@chakra-ui/react";
import { useRouter } from "next/router";
import { useEffect, useRef } from "react";
import { useUser } from "../../contexts/useUser";

import { AvatarMenu } from "./AvatarMenu";

export function Profile({ isOpen, onOpen, onClose }) {

  const router = useRouter();
  const subMenuRef = useRef<HTMLDivElement | null>();
  const { user } = useUser();

  const toggle = () => {
    if (isOpen) {
      onClose();
    } else {
      onOpen();
    }
  }

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (subMenuRef.current && !subMenuRef.current.contains(event.target as Node)) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (isOpen) {
      onClose();
    }
  }, [router]);

  return (
    <Box position="relative" ref={subMenuRef}>
      <Avatar
        size="md"
        width="48px !important"
        height="48px !important"
        border="2px"
        bg="red.400"
        padding="unset !important"
        color="white.400"
        onClick={toggle}
        cursor="pointer"
        transition="background-color 0.25s"
        name={user ? (user.first_name + ' ' + user.last_name) : ''}
        sx={{
          '& > div': {
            fontSize: '19px !important',
            lineHeight: '48px !important'
          }
        }}
        _hover={{
          bg: "black"
        }}
      />
      <Fade in={isOpen}>
        <Box
          position="absolute"
          top="50px"
          right="0"
          background="white.400"
          width="max-content"
          boxShadow="lg"
          rounded="md"
          border="1px solid #ebebeb"
          pointerEvents={isOpen ? 'unset' : 'none'}
        >
          <AvatarMenu />
        </Box>
      </Fade>
    </Box>
  );
}
